import React, { Component } from 'react';
import { connect } from 'react-redux';
import Typography from 'material-ui/Typography';
import Card, { CardContent } from 'material-ui/Card';
import { withStyles } from 'material-ui/styles';
import ActionExitToApp from 'material-ui-icons/ExitToApp';
import {
  OAuthSignInButton,
  OAuthSignOutButton
} from 'components';
import styles from './styles';
import googleLogo from '/images/search.png';
import xeroLogo from '/images/xero.png';
import List, { ListItem } from 'material-ui/List';

class Login extends Component {
  googleLogo = () => {
    return <img src={googleLogo} style={{ width: '20px', marginTop: '0px' }}/>
  }

  xeroLogo = () => {
    return <img src={xeroLogo} style={{ width: '20px', marginTop: '0px' }}/>
  }

  render = () => {
    const { signedIn } = this.props;

    return (
      signedIn ? (
        <OAuthSignOutButton>
          Sign Out
        </OAuthSignOutButton>
        ) : (
        <div>
          <Card style={{ margin: '200px auto 0', width: '300px', textAlign: 'center' }}>
            <CardContent>
              <Typography type="body1" color="inherit">
                One click application with Xero
              </Typography>
              <OAuthSignInButton provider='xero' icon={this.xeroLogo()}>
                Xero
              </OAuthSignInButton>
            </CardContent>
          </Card>

          <Card style={{ margin: '20px auto', width: '300px', textAlign: 'center' }}>
            <CardContent>
              <Typography type="body1" color="inherit">
                Login and let us know your business
              </Typography>
              <OAuthSignInButton
                provider='google'
                icon={this.googleLogo()}
                signInParams={{ prompt: 'consent' }}
              >
                Google
              </OAuthSignInButton>
            </CardContent>
          </Card>
        </div>
        )
    );
  }
}

const mapStateToProps = (state) => {
  const signedIn = !!state.auth.getIn(['user', 'isSignedIn']);
  return { signedIn };
};

const component = connect(mapStateToProps)(Login);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js